import { Spinner } from '@material-tailwind/react'
import React, { Fragment } from 'react'
import ASpinner from '../partials/ASpinner'
import Skeleton from '../skeleton/Skeleton'

export default function EmptyTable({ value }) {
  return (
    <>
          {value.loading === 2 &&value.length === 0 && <p className=' left-1/2 grid place-items-center h-[50%] text-sm'>No data available</p>}
         {/*  {  value.loading===1  && <Skeleton />} */}
          {value.loading === 1 && <ASpinner />}
    </>
  )
}
